export default __webpack_public_path__ + "static/media/eu.395d0fb2.svg";